import {_, moment} from "../../../../../vendor";
import {in_array} from "../../../../utils/Helper";
import t from "../../../helpers/t";
import {rbac} from "../index";
import {Biscuit} from "../../../../utils";
import {ordersActions, reservationsActions, userActions, useSelector} from "inbooma-api";
import OrderListItem from "./OrderListItem";
import React, {useEffect, useState} from "react";
import * as OrderFunctions from "./behaviors/OrderFunctions";
import {dateFormat} from "../../../../utils/FormatHelper";

const OrderItem = (props) =>
{
    const {
        order,
        index,
        dispatch,
        _exchangeLabel,
        setCheckout,
        checkout,
        setCheckoutCheckin,
        setCheckoutReservation,
        setFilter,
        filter,
        setNKey,
        sort,
        setSort,
        _key,
        locations,
        orderMenu,
        setPopup,
        popup,
        searchParams,
        filterChangedHandle,
        showNotification
    } = props;
    const _user = useSelector(state => state.users_data.user);
    let language = Biscuit.get('user.lang').replace('-','_');
    const [reservationsPending,setReservationsPending] = useState(false);
    const [ordersPending,setOrdersPending] = useState(false);
    const _patchReservation = useSelector(state => state.reservations.patchReservations);
    const _patchOrder = useSelector(state => state.orders.patchOrder);
    const [initialized,setInitialized] = useState(false);
    const [localOrder, setLocalOrder] = useState(order);
    useEffect(() => {

        if (_user.success === "") return;

        if (_user.success === true) {

            let info = typeof _user.data.first_name !== 'undefined' && _user.data.first_name !== null ? _user.data.first_name : "";
            info += typeof _user.data.last_name !== 'undefined' && _user.data.last_name !== null ? " " + _user.data.last_name : "";

            // show popup with user info and link to user profile
            setPopup({
                left: popup.left,
                top: popup.top,
                open: true,
                text: popup.text,
                link: "users/" + _user.data.id + "?path=/reservations/reservationsList",
                linkText: info.length == 0 ? _user.data.id : info
            });
        } else {
            console.log("Failed to fetch user");
        }
    },[_user]);
    useEffect(() => {
        if (!reservationsPending || _patchReservation.success === "") {
            return;
        }

        if (_patchReservation.success === true) {

        } else {
            console.log("Failed patching reservation!");
        }
        setReservationsPending(false);
        // props.filterChangedHandle(props.filter);
    },[_patchReservation]);

    useEffect(() => {
        if (!ordersPending || _patchOrder.success === "") {
            return;
        }

        if (_patchOrder.success === true) {
            const clone = {};
            Object.assign(clone,localOrder);
            clone.status = _patchOrder.data.status;
            setLocalOrder(clone);
            //fillData();
            showNotification('success',clone.order_nbr);
           //filterChangedHandle(filter);
        } else {
            if(typeof _patchOrder?.data?.code  !== 'undefined'){
               if(_patchOrder?.data?.code === 422) {
                   console.log(_patchOrder.data?.errors?.status)
                   showNotification('warning',localOrder.order_nbr,(typeof _patchOrder.data?.errors?.status?.inList !== 'undefined'?_patchOrder.data?.errors?.status?.inList:t('could_not_be_saved_${a}',{a:t('order')},'capital')+' #'+ localOrder.order_nbr));
               }
            } else {
                showNotification('warning', localOrder.order_nbr, (typeof _patchOrder.data.message !== 'undefined' ? _patchOrder.data.message : t('could_not_be_saved_${a}', {a: t('order')}, 'capital') + ' #' + localOrder.order_nbr));
            }
            console.log("Failed patching order!");
        }
        dispatch(ordersActions.patchOrderResetData());
        setOrdersPending(false);
        //
    },[_patchOrder]);

    useEffect(() => {
        fillData();
    },[ordersPending])

    const onStatusChangedHandler = (e, item) => {
        if(typeof item.order_id !== 'undefined') {
            dispatch(reservationsActions.patchReservations({
                token: Biscuit.get('token'),
                reservation_id: item.id,
                data: {
                    status: e.target.value
                },
                parameters: {
                    headers: {
                        "Accept-Language": language,
                        "Content-Language": language
                    }
                }
            }));
            setReservationsPending(true);
        } else {
            dispatch(ordersActions.patchOrder({
                token: Biscuit.get('token'),
                order_id: item.id,
                data: {
                    status: e.target.value
                },
                parameters: {
                    headers: {
                        "Accept-Language": language,
                        "Content-Language": language
                    }
                }
            }));
            setOrdersPending(true);
        }


    }
    const onItemClickedHandler = (value) => {

        console.log("clicked on: ", value);
        if (value.startsWith('acc_invoice_')) {

            // open accumulated invoice
            const id = value.split('acc_invoice_')[1];


        }
        if (value.startsWith('user_')) {

            // fetch user info
            const id = value.split('user_')[1];
            const el_rect = document.getElementsByName(value)[0].getBoundingClientRect();

            dispatch(userActions.getUser({
                token: Biscuit.get('token'),
                id: id
            }));

            setPopup({
                ...popup,
                left: el_rect.left + "px",
                top: el_rect.top + "px",
                text: t('user',null,'capital') + ':'
            });
        }

    };

    let elements = [];
    let orderIds = [];

    let hasReservation = typeof localOrder.reservations !== 'undefined' && localOrder.reservations !== null && localOrder.reservations.length;
    let reservations=null;
    let hasCheckIn = false;
    if(hasReservation){
        reservations = localOrder.reservations;
        reservations.map(reserv => {
            hasCheckIn = typeof reserv.checkins !== 'undefined' && reserv.checkins !== null && reserv.checkins.length > 0;
        });
    }
    let toggle = false;
    if(typeof searchParams.get("item") !== 'undefined' && searchParams.get("item") !== null && localOrder.id == searchParams.get("item")){
        toggle=true;
    }

    let addClasses = '';
    if (localOrder.status === 'cancelled') {
        addClasses += ' is-cancelled';
    }
    let hasFormData = false,
        hasTour = false;

    if (localOrder !== null && typeof localOrder.tag_list !== 'undefined') {
        let tags = localOrder.tag_list.split(',');
        _.each(tags, function (val, k) {
            if (val.trim() === "Anlieferungen") {
                hasFormData = true;
            }
            if (val.trim() === "Tour") {
                hasTour = true;
            }
        });

    }

    if (hasFormData && (localOrder.status === 'confirmed' || localOrder.status === 'paid')) {
        addClasses += ' has-form-data';
    } else if(hasFormData && localOrder.status === 'requested') {
        addClasses += ' has-form-data-requested';
    } else {
        addClasses += ' has-no-form-data';
    }

    if(hasTour){
        addClasses += ' has-tour';
    } else {
        addClasses += ' has-no-tour';
    }

    if(localOrder.types === 'service'){
        addClasses += ' is-service';
    } else {
        addClasses += ' is-no-service';
    }
    let lastReservation = 0;
    if(hasReservation){
        lastReservation = localOrder.reservations.length - 1;
    }
    if(toggle){
        addClasses += ' toggled';
    }
    let orderData = [];
    const fillData = () => {
        if (!hasFormData) {
            if (!in_array(localOrder.id, orderIds)) {
                orderIds.push(localOrder.id);
                elements = [{
                    type: "text",
                    value: "date",
                    title: "",
                    data: [{
                        value: "date",
                        text: !hasReservation ? t('no_linked_reservations') : {
                            0: moment(localOrder.reservations[0].begin).format(dateFormat(language,true)),
                            1: moment(localOrder.reservations[lastReservation].end).format(dateFormat(language,true))
                        },
                        extraClasses: "inb-order-date__start inb-order-big",
                        title: hasReservation ? {
                            0: t('contains_reservations_from', null, 'capital') + " " + moment(localOrder.reservations[0].begin).format(dateFormat(language,true,true)),
                            1: t('contains_reservations_till', null, 'capital') + " " + moment(localOrder.reservations[lastReservation].end).format(dateFormat(language,true,true))
                        } : ''
                    }],
                    mediumWidth: 8,
                    smallWidth: 8,
                    extraTopClasses: "large-2",
                    handler: onItemClickedHandler
                },
                    {
                        type: "text",
                        value: "order_nbr",
                        title: "",
                        extraTopClasses: "large-3",
                        data: [rbac.hasPermission('edit') ? {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "newline hide-for-small-only",
                            title: t('order_nbr', null, 'capital'),
                            ref: '/orders/' + localOrder.id + '/edit'
                        } : {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "hide-for-small-only",
                            title: t('order_nbr', null, 'capital')
                        },rbac.hasPermission('edit') ? {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "newline show-for-small-only",
                            title: t('order_nbr', null, 'capital')+': '+t('order_nbr', null, 'capital'),
                            ref: '/orders/' + localOrder.id + '/edit'
                        } : {
                            value: "order_nbr",
                            text: t('order_nbr', null, 'capital')+': '+localOrder.order_nbr,
                            extraClasses: "newline show-for-small-only",
                            title: t('order_nbr', null, 'capital')
                        }, {
                            value: "contingents",
                            text: OrderFunctions.printContingentsAmountList(localOrder, true),
                            extraClasses: "inb-reservation--object",
                            title: ""
                        }],
                        mediumWidth: 8,
                        smallWidth: 12,
                        extraTopClasses: "large-3",
                        handler: onItemClickedHandler
                    },
                    {
                        type: "text",
                        value: "description",
                        title: "",
                        extraTopClasses: "inb-order--customer",
                        data: [{
                            value: "user",
                            text: OrderFunctions.getOrderUsername(localOrder),
                            extraClasses: "newline",
                            title: t('user', null, 'capital')
                        }, rbac.hasPermission('edit') ? {
                            value: "user_profile",
                            text: t('open_profile'),
                            extraClasses: "",
                            title: "",
                            ref: OrderFunctions.getOrderUserLink(localOrder)
                        } : {}],
                        mediumWidth: 8,
                        smallWidth: 12,
                        extraTopClasses: "large-3",
                        handler: onItemClickedHandler
                    },
                    rbac.hasPermission('editStatus') ? {
                        type: "select",
                        value: localOrder.status,
                        title: t('status'),
                        data: OrderFunctions.getOrderStatusSelect(localOrder),
                        extraClasses: "text-small word-break-all inb-order--status",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-2",
                        badge: true,
                        extraData: localOrder,
                        handler: (e) => onStatusChangedHandler(e, localOrder),
                        listenPending: true
                    } : {
                        type: "text",
                        value: localOrder.status,
                        title: t('status'),
                        data: [
                            {
                                value: "status",
                                text: t(localOrder.status),
                                extraClasses: "",
                                title: ""
                            }
                        ],
                        extraClasses: "text-small word-break-all inb-order--status",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-2",
                    },
                    {
                        type: "text",
                        value: localOrder.price,
                        title: t('price'),
                        data: [{
                            value: "price",
                            text: Number(localOrder.price).toLocaleString("de-DE", {minimumFractionDigits: 2}) + " " + Biscuit.get('client.currency'),
                            extraClasses: "",
                            title: ""
                        }],
                        extraClasses: "inb-order-price__amount inb-order-big",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-1",
                        handler: onItemClickedHandler
                    }];
            }

            /* if(hasCheckIn && Biscuit.get('client.isVehicleOwner') === 'true') {
                 elements.push({
                     type: "bar",
                     value: "state",
                     title: "",
                     data: [{
                         value: "state",
                         text: getState(reserv),
                         extraClasses: getStateClasses(reserv),
                         extra: (reserv.checkins[0].checkout !== null ? 'has-checkout' : ""),
                         title: ""
                     }],
                     mediumWidth: 12,
                     smallWidth: 12,
                     handler: onItemClickedHandler
                 });
             }*/

            if (hasCheckIn) {
                /*elements.push({
                    type: "CheckInAddition",
                    value: "checkins",
                    title: "",
                    data: [{
                        value: "checkins",
                        text: "",
                        title: "",
                        order_id: localOrder.id,
                        checkins: localOrder.reservations[0].checkins,
                        first_usage: localOrder.reservations[0].first_usage,
                        id: localOrder.reservations[0].id,
                        app_user_role: Biscuit.get('user.role'),
                        reservation: localOrder.reservations[0],
                        dispatch: props.dispatch,
                        checkout: props.checkout,
                        setCheckout: props.setCheckout,
                        setCheckoutReservation: setCheckoutReservation,
                        setCheckoutCheckin: setCheckoutCheckin
                    }],
                    mediumWidth: 12,
                    smallWidth: 12,
                    handler: onItemClickedHandler
                });*/
            }
        } else {
            if (!in_array(localOrder.id, orderIds)) {
                orderIds.push(localOrder.id);
                elements = [{
                    type: "text",
                    value: "date",
                    title: "",
                    data: [{
                        value: "date",
                        text: !hasReservation ? t('no_linked_reservations') : {
                            0: moment(localOrder.reservations[0].begin).format(dateFormat(language,true)),
                            1: moment(localOrder.reservations[lastReservation].end).format(dateFormat(language,true))
                        },
                        extraClasses: "inb-order-date__start inb-order-big",
                        title: hasReservation ? {
                            0: t('contains_reservations_from', null, 'capital') + " " + moment(localOrder.reservations[0].begin).format(dateFormat(language,true, true)),
                            1: t('contains_reservations_till', null, 'capital') + " " + moment(localOrder.reservations[lastReservation].end).format(dateFormat(language,true,true))
                        } : ''
                    }],
                    mediumWidth: 8,
                    smallWidth: 12,
                    extraTopClasses: "large-2",
                    handler: onItemClickedHandler
                },
                    {
                        type: "text",
                        value: "order_nbr",
                        title: "",
                        extraTopClasses: "",
                        data: [rbac.hasPermission('edit') ? {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "newline hide-for-small-only",
                            title: t('order_nbr', null, 'capital'),
                            ref: '/orders/' + localOrder.id + '/edit'
                        } : {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "newline hide-for-small-only",
                            title: t('order_nbr', null, 'capital')
                        },rbac.hasPermission('edit') ? {
                            value: "order_nbr",
                            text: localOrder.order_nbr,
                            extraClasses: "newline show-for-small-only",
                            title: t('order_nbr', null, 'capital')+': '+t('order_nbr', null, 'capital'),
                            ref: '/orders/' + localOrder.id + '/edit'
                        } : {
                            value: "order_nbr",
                            text: t('order_nbr', null, 'capital')+': '+localOrder.order_nbr,
                            extraClasses: "newline show-for-small-only",
                            title: t('order_nbr', null, 'capital')
                        }, {
                            value: "contingents",
                            text: OrderFunctions.printContingentsAmountList(localOrder, true),
                            extraClasses: "inb-reservation--object",
                            title: ""
                        }],
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-3",
                        handler: onItemClickedHandler
                    },
                    {
                        type: "text",
                        value: "description",
                        title: "",
                        extraTopClasses: "inb-order--customer",
                        data: [{
                            value: "user",
                            text: OrderFunctions.getOrderUsername(localOrder),
                            extraClasses: "newline",
                            title: t('user', null, 'capital')
                        }, rbac.hasPermission('editStatus') ? {
                            value: "user_profile",
                            text: t('open_profile'),
                            extraClasses: "",
                            title: "",
                            ref: OrderFunctions.getOrderUserLink(localOrder)
                        } : {}],
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-3",
                        handler: onItemClickedHandler
                    },
                    rbac.hasPermission('editStatus') ? {
                        type: "select",
                        value: localOrder.status,
                        title: t('status'),
                        data: OrderFunctions.getOrderStatusSelect(localOrder),
                        extraClasses: "text-small word-break-all inb-order--status",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-2",
                        badge: true,
                        extraData: localOrder,
                        handler: (e) => onStatusChangedHandler(e, localOrder, index),
                        listenPending: true
                    } : {
                        type: "text",
                        value: localOrder.status,
                        title: t('status'),
                        data: [
                            {
                                value: "status",
                                text: t(localOrder.status),
                                extraClasses: "",
                                title: ""
                            }
                        ],
                        extraClasses: "text-small word-break-all inb-order--status",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-2"
                    },
                    {
                        type: "text",
                        value: localOrder.price,
                        title: t('price'),
                        data: [{
                            value: "price",
                            text: Number(localOrder.price).toLocaleString("de-DE", {minimumFractionDigits: 2}) + " " + Biscuit.get('client.currency'),
                            extraClasses: "",
                            title: ""
                        }],
                        extraClasses: "inb-order-price__amount inb-order-big",
                        mediumWidth: 8,
                        smallWidth: 8,
                        extraTopClasses: "large-1",
                        handler: onItemClickedHandler
                    }
                ];
                if (hasReservation && rbac.hasPermission('edit')) {
                    elements.push({
                        type: "specialButtons",
                        value: t('mietvertrag_help'),
                        title: t('mietvertrag_help'),
                        extraTopClasses: "large-1",
                        data: [{
                            value: localOrder,
                            icon: "inb-fi-contract",
                            extraClasses: "inb-round-btn hollow round float-left",
                            ref: '#',
                            round: true
                        }],
                        mediumWidth: 6,
                        smallWidth: 6,
                        handler: OrderFunctions._printRentalContractDelivery
                    })
                }
            }
        }
        if (elements !== []) {
            orderData[index] = {
                elements: elements,
                addClasses: addClasses,
                hasForm: hasFormData,
                hasReservation: hasReservation,
                changeLogs: localOrder.changeLogs
            };
        }
    }
    fillData();

     return (
         <>
             {orderData.length > 0 && <OrderListItem
                 order={localOrder}
                 locations={locations}
                 refLink={"reservations/orders"}
                 hasReservation={orderData.hasReservation}
                 _exchangeLabel={_exchangeLabel}
                 app_user_role={Biscuit.get('user.role')}
                 setCheckoutReservation={setCheckoutReservation}
                 setCheckoutCheckin={setCheckoutCheckin}
                 setCheckout={setCheckout}
                 checkout={checkout}
                 dispatch={dispatch}
                 length={typeof localOrder.reservations !== 'undefined'?localOrder.reservations.length:0}
                 key={"wti-" + index}
                 listStyle="tight"
                 id={"row-" + localOrder.id}
                 overwriteClasses={"inb-c-item inb-c-item--order row " + orderData[index].addClasses}
                 elements={orderData[index].elements}
                 setFilter={setFilter}
                 filter={filter}
                 setNKey={setNKey}
                 sort={sort}
                 setSort={setSort}
                 _key={_key}
                 menu={orderMenu}
                 itemPending={ordersPending}
                 showNotification={showNotification}
             />}
         </>
     );
    }
export default OrderItem;